module.exports = __webpack_public_path__ + "static/media/8.8fad20e2.jpg";